import get from 'lodash/get';

/**
 * Filter out variants.
 * @param variants
 * @return {{variants: *, filteredOutVariants: []}}
 */
const filterOutVariants = (variants) => {
  let filteredOutVariants = [];
  variants = variants.filter((variant) => {
    if (variant.isArchived) {
      filteredOutVariants.push(variant.code);
    }
    return !variant.isArchived;
  });

  return {variants, filteredOutVariants};
};

/**
 * Filter out items from hierarchy.
 * @param values
 * @param filteredOutVariants
 * @return {*}
 */
const filterHierarchy = (values, filteredOutVariants) => {
  if (!values || !values.length) {
    return values;
  }

  const hasChildren = (parent) => parent.children && parent.children.length > 0;
  for (let n = values.length - 1; n >= 0; --n) {
    const productCode = get(values[n], 'options.productCode');
    const initiallyHasChildren = hasChildren(values[n]);

    if (initiallyHasChildren) {
      filterHierarchy(values[n].children, filteredOutVariants);
    }

    if (!hasChildren(values[n]) && (filteredOutVariants.indexOf(productCode) > -1 || initiallyHasChildren)) {
      values.splice(n, 1);
    }
  }

  return values;
};

/**
 * Filter out archived variants and options for not archived base product.
 * @param data
 * @return {{isArchived}|{variants}|*}
 */
const filterArchivedProducts = (data) => {
  if (!data || !Object.keys(data).length || !data.variants || data.isArchived) {
    return data;
  }

  const {variants, filteredOutVariants} = filterOutVariants(data.variants);

  data.variants = variants;
  data.categorizationHierarchyValues = filterHierarchy(data.categorizationHierarchyValues, filteredOutVariants);

  return data;
};

export {filterArchivedProducts};
